import { SuricataSnortAlert, SuricataSort } from "./types";

export const handleSuricataSort = (
  data?: Array<SuricataSnortAlert>,
  sort?: SuricataSort
) => {
  if (!sort || !data) {
    return data ?? [];
  }

  return [...data].sort((a, b) => {
    let aValue = sort.field === "rule" ? a.source_id || a.rule : a[sort.field];
    let bValue = sort.field === "rule" ? b.source_id || b.rule : b[sort.field];

    if (!aValue) {
      return sort.direction === "asc" ? -1 : 1;
    }
    if (!bValue) {
      return sort.direction === "asc" ? 1 : -1;
    }

    if (typeof aValue === "number" && typeof bValue === "number") {
      return sort.direction === "asc" ? aValue - bValue : bValue - aValue;
    }

    const aString = String(aValue).toLowerCase();
    const bString = String(bValue).toLowerCase();

    if (sort.direction === "asc") {
      return aString.localeCompare(bString);
    } else {
      return bString.localeCompare(aString);
    }
  });
};
